document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-list__list-item');
  
  menuItems.forEach(item => {
    const submenu = item.querySelector('.menu-list__submenu');
    
    if (submenu) {
      let closeTimer;
      
      // Fonction pour garder le menu ouvert
      const keepOpen = () => {
        clearTimeout(closeTimer);
        item.classList.add('is-hovered');
      };
      
      // Fonction pour fermer après délai
      const scheduleClose = () => {
        closeTimer = setTimeout(() => {
          item.classList.remove('is-hovered');
        }, 800); // 800ms de délai
      };
      
      // Événements sur l'élément parent
      item.addEventListener('mouseenter', keepOpen);
      item.addEventListener('mouseleave', scheduleClose);
      
      // Événements sur le submenu lui-même
      submenu.addEventListener('mouseenter', keepOpen);
      submenu.addEventListener('mouseleave', scheduleClose);
    }
  });
});